import { useMutation } from 'react-query';
import { downloadFile } from '../../../lib/download';

export const useDownloadDocument = () => {
    return useMutation(downloadFile);
};
